var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-wrap"},[_c('el-pagination',{attrs:{"size":_vm.paginationSize,"page-sizes":_vm.pageSizeOptions,"total":_vm.total,"page-size":_vm.pageSize,"current-page":_vm.page,"layout":_vm.layout},on:{"size-change":_vm.sizeChange,"current-change":_vm.currentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }